import React, { useEffect, useState } from 'react'
import { Button, Modal, Form, Toast } from '@themesberg/react-bootstrap'

export default function TicketEmployeeFormModal({ show, mode, employee, onHide, onSubmit }) {
  const isEdit = mode === 'edit'

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (!show) return
    setError('')
    setPassword('')
    if (isEdit && employee) {
      setUsername(employee.username || '')
      setName(employee.name || '')
      setPhone(employee.phone || '')
    } else {
      setUsername('')
      setName('')
      setPhone('')
    }
  }, [show, isEdit, employee])

  const handleSubmit = async () => {
    setError('')
    if (!isEdit && (!username || !password || password.length < 6)) {
      setError('Tên đăng nhập và mật khẩu (tối thiểu 6 ký tự) là bắt buộc')
      return
    }

    const payload = {
      name: name || null,
      phone: phone || '',
    }

    if (!isEdit) {
      payload.username = username
      payload.password = password
      payload.status = 1
    } else {
      payload.id = employee.id
    }

    const result = await onSubmit(payload)
    if (result?.error) {
      setError(result.message || 'Có lỗi xảy ra')
      return
    }
    onHide(true)
  }

  return (
    <Modal show={show} onHide={() => onHide(false)} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? 'Sửa nhân viên in vé' : 'Thêm nhân viên in vé'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Toast show className="d-block mb-3" bg="danger">
            <Toast.Body className="text-white">{error}</Toast.Body>
          </Toast>
        )}
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Tên đăng nhập</Form.Label>
            <Form.Control
              type="text"
              value={username}
              disabled={isEdit}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </Form.Group>
          {!isEdit && (
            <Form.Group className="mb-3">
              <Form.Label>Mật khẩu</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={6}
                required
              />
            </Form.Group>
          )}
          <Form.Group className="mb-3">
            <Form.Label>Tên hiển thị</Form.Label>
            <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Số điện thoại</Form.Label>
            <Form.Control type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onHide(false)}>
          Đóng
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {isEdit ? 'Lưu' : 'Thêm'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
